'use strict';

const videoCategory = 'Video';
const playAction = 'Play';
const oneMinuteProgressAction = 'Video60Sec';

class SlideshowVideoCtrl {
  constructor($window, $scope, $element, analytics) {
    const iframe = $element.find('iframe').eq(0);
    const handleMessage = this.handleMessage.bind(this);

    this.$scope = $scope;
    this.analytics = analytics;

    this.iframe = iframe;
    this.playerOrigin = '*';


    $window.addEventListener('message', handleMessage, false);
    $element.on('$destroy', () => {
      window.removeEventListener('message', handleMessage, false);
      this.unbindWatcher && this.unbindWatcher();
    });
  }

  /**
   * Handles Vimeo player events.
   * More info: https://developer.vimeo.com/player/js-api#methods
   *
   * @param event
   */
  handleMessage(event) {
    var parsedEvent;

    if (!(/^https?:\/\/player.vimeo.com/).test(event.origin)) {
      return;
    }

    if (this.playerOrigin === '*') {
      this.playerOrigin = event.origin;
    }

    if (typeof event.data === 'object') {
      parsedEvent = event.data;
    } else {
      parsedEvent = JSON.parse(event.data);
    }


    switch (parsedEvent.event) {
    case 'ready':
      this.handleReady();
      break;

    case 'play':
      this.handlePlay();
      break;

    case 'playProgress':
      this.handlePlayProgress(parsedEvent.data);
      break;

    default:
      break;
    }
  }

  /**
   * Handles Vimeo player ready event.
   */
  handleReady() {
    this.postMessage('addEventListener', 'play');
    this.postMessage('addEventListener', 'playProgress');

    if (this.isActive) {
      this.postMessage('play');
    }

    this.unbindWatcher = this.$scope.$watch('ctrl.isActive', (isActive) => {
      if (!isActive) {
        this.postMessage('pause');
      }
    });
  }

  handlePlay() {
    if (this._hasSentPlayEvent) {
      return;
    }

    this.sendAnalyticsEvent(playAction);
    this._hasSentPlayEvent = true;
  }

  handlePlayProgress(progressData) {
    if (this._hasSentProgressEvent) {
      return;
    }

    if (progressData.seconds < 60) {
      return;
    }

    this.sendAnalyticsEvent(oneMinuteProgressAction);
    this._hasSentProgressEvent = true;
  }

  sendAnalyticsEvent(action) {
    this.analytics.track(action, {
      category: videoCategory,
      label: `${this.video.name} ${this.video.guideId}`
    });
  }

  /**
   * Calls Vimeo player JS API method.
   * @param methodName {String}
   * @param [value] {String}
   */
  postMessage(methodName, value) {
    const data = {
      method: methodName
    };

    if (value) {
      data.value = value;
    }

    this.iframe[0].contentWindow.postMessage(data, this.playerOrigin);
  }

  getSrc() {
    return `//player.vimeo.com/video/${this.video.vimeoId}?autoplay=1`;
  }
}

SlideshowVideoCtrl.$inject = [
  '$window',
  '$scope',
  '$element',
  'analytics'
];

export default SlideshowVideoCtrl;



// WEBPACK FOOTER //
// ./app/src/common/slideshow/slideshow_video.js